import { defineStore } from 'pinia'

const useCommentStore = defineStore('comment', {
  state: () => ({}),
  actions: {},
})

export default useCommentStore
